// extracted by mini-css-extract-plugin
export default {"Checkbox":"TermsCheckbox_Checkbox__uuqMA"};